import { render, staticRenderFns } from "./AccountRemoveAction.vue?vue&type=template&id=1c04e9e3"
import script from "./AccountRemoveAction.vue?vue&type=script&lang=js"
export * from "./AccountRemoveAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports